import { FooterPage } from 'pages/FooterPage';
import React from 'react';

const Footer = () => {
    return (
        <FooterPage />
    );
};

export default Footer;